<template>
  <v-container
    fluid
    class="firma-container"
  >
    <v-row class="cms-filter-row">
      <v-col class="pl-3 pl-sm-0">
        <SelectCategory
          :categories="categories"
          :index="query.index"
          v-model="query.category"
          :updateQuery="updateQuery"
          flat
          solo
          dense
          class="expert-input dropdown dropdown-2"
          color="#636363"
          itemColor="#636363"
        ></SelectCategory>
      </v-col>
      <v-col class="pr-3 pr-sm-0">
        <SelectTime
          class="expert-input dropdown dropdown-2"
          color="#636363"
          itemColor="#636363"
          flat
          solo
          dense
          v-model="query.time"
          :updateQuery="updateQuery"
        ></SelectTime>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pa-0">
        <div :style="hasNoResult ? '' : 'padding-top: 135px;'">
          <NoResult v-if="hasNoResult"></NoResult>
          <Post :items="hits"></Post>
          <Pagination
            v-if="nbHits > 0"
            v-model="query.page"
            :length="nbPages"
            @input="(page) => updateQuery({ page })"
          ></Pagination>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import SelectCategory from '@/components/shared/search/select/Category';
import SelectTime from '@/components/shared/search/select/Time';
import NoResult from './NoResult';
import Post from './Post';
import Pagination from '@/components/shared/pagination/Pagination';

export default {
  name: 'Cms',
  components: {
    SelectCategory,
    SelectTime,
    NoResult,
    Post,
    Pagination,
  },
  props: {
    categories: {
      type: Object,
      required: true,
    },
    updateQuery: {
      type: Function,
      required: true,
    },
    hits: {
      type: Array,
      required: true,
    },
    hasNoResult: {
      type: Boolean,
      required: true,
    },
    nbPages: {
      type: Number,
      required: true,
    },
    nbHits: {
      type: Number,
      required: true,
    },
  },
  data() {
    const { 
      page,
      category,
      time,
      index,
    } = this.$route.query;
    return {
      query: {
        page: page || 1,
        category: category || this.$t('all'),
        time: time || { text: 'all', value: null},
        index: index || 'dev_cms_german',
      },
    }
  },
}
</script>